// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { getEmojiStylesByWidth } from "@msnews/social-utils";

export const MiniReactionBreakdownStyles = (config: DesignSystem) => ({
    miniReactionBreakdownContainer: {
        "pointer-events": "none",
        display: "flex !important",
        "align-items": "center",
        "justify-content": "center",
        padding: "6px 8px",
        background: neutralLayerCard,
        "border-radius": "32px",
        "-webkit-box-shadow": "0px 3.2px 7.2px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px rgba(0, 0, 0, 0.1)",
        "-moz-box-shadow": "0px 3.2px 7.2px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px rgba(0, 0, 0, 0.1)",
        "box-shadow": "0px 3.2px 7.2px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px rgba(0, 0, 0, 0.1)",

        "& div.emoji-icon": {
            ...getEmojiStylesByWidth(16),
            transition: "none"
        },

        "& i.cwt-icon.cwt-count-icons": {
            display: "flex",
            margin: "0 0 !important",
            padding: "2px 2px !important",
            "font-size": "18px",
            color: neutralForegroundRest,

            "&:last-child": {
                "margin-bottom": "0 !important"
            },

            "& .cwt-icon-label": {
                "font-size": "14px",
                "font-weight": "normal"
            }
        }
    },

    miniReactionBreakdownPopover: {
        top: "-48px",
        [applyLocalizedProperty("left", "right", config.direction)]: "-50%"
    }
});